define.alias("shared/components/shared/ui/switcher/action", "preview-grid/components/shared/ui/switcher/action");